import { SSOEnabledInstance } from '@robocorp/robocloud-sso-management-interface';
import { useQueryClient } from '@tanstack/react-query';
import { getRealmMetadataQueryKey } from '~/queries/useAuthQuery';
import { EnhancedRealmMetadata, getRealmFallbackData } from '~/utils/cloudHelper';

const realmPlaceholderData = getRealmFallbackData(window.location);

type SSOMetadata = {
  isSSO: true;
  realm: string;
  instanceId: SSOEnabledInstance;
};

type NonSSOMetadata = {
  isSSO: false;
  realm: undefined;
  instanceId: undefined;
};

const hasSSOMetadata = (
  unknownMetadata: SSOMetadata | NonSSOMetadata | EnhancedRealmMetadata,
): unknownMetadata is SSOMetadata => unknownMetadata.isSSO;

/**
 * Hook expected to be used only after user is authenticated - otherwise refer to useRealmMetadataQuery
 * Returns realm info directly from cache so we don't need to check if virtual room on each usage
 */
export const useIsSSO = (): SSOMetadata | NonSSOMetadata => {
  const queryClient = useQueryClient();
  const realmMeta: EnhancedRealmMetadata =
    queryClient.getQueryData(getRealmMetadataQueryKey(window.location)) ?? realmPlaceholderData;

  if (hasSSOMetadata(realmMeta)) {
    return realmMeta;
  }

  return {
    isSSO: false,
    realm: undefined,
    instanceId: undefined,
  };
};
